import { Space, Text } from '@billy/design-system'
import React from 'react'

import { getImgPath } from '../../../../../../utils/getImgPath'
import { type CarouselUpsellWidget } from '../../hooks/useCarouselUpsellWidgets'
import * as Styled from './styles'

export const CarouselItem = ({
  backgroundColor,
  description,
  subtitle,
  title,
  img,
  renderButton,
}: Omit<CarouselUpsellWidget, 'id' | 'shouldDisplay'>) => {
  return (
    <Styled.CarouselWidgetContainer backgroundColor={backgroundColor}>
      <Styled.ContentContainer>
        <Styled.TextContainer>
          <Text weight="bold" uppercase colorVariant="secondary" variant="bodySM">
            {subtitle}
          </Text>
          <Space size="s6" />
          <Text variant="h2" colorVariant="primary">
            {title}
          </Text>
          <Space size="s8" />
          <Styled.Description>{description}</Styled.Description>
          <Space size="s16" />
        </Styled.TextContainer>
        <div>{renderButton()}</div>
      </Styled.ContentContainer>

      <Styled.ImageContainer>
        <Styled.Illustration src={getImgPath(img.src)} alt={img.alt} />
      </Styled.ImageContainer>
    </Styled.CarouselWidgetContainer>
  )
}
